import { observable } from "mobx"
import { IShortCompanyInfo, IStockSymbol, STOCK_BG_COLOR_CONIG } from "../../common/model/Model";
import { appStore } from "../../common/store/AppStore";
import _ from 'lodash'
import { getRequest } from "../../common/helpers/RequestHelper";
import Constants from "../../common/constants/Constants";
import HttpStatusCode from "../../common/constants/HttpErrorCode";
import { IMarketIndex } from './../../common/model/Model';
export enum OrderMatchingByPriceViewType {
    ByChart = 1,
    ByTable = 2
}
const listTime = [
    {
        title: "1 ngày",
        value: "1"
    },
    {
        title: "5 ngày",
        value: "5"
    },
    {
        title: "10 ngày",
        value: "10"
    },
    {
        title: "20 ngày",
        value: "20"
    }
]
interface IAreaLineData {
    buyData: string[][];
    sellData: string[][];
    priceData: string[][];
    unknownData: string[][];
}
export interface QuantitiesData {
    sellQtty: number[];
    buyQtty: number[];
    unknownQtty: number[];
}

export interface IBarData {
    basicPrice: number;
    matchPrice: number[];
    quantitiesData: any;
}
interface ITableData {
    time: string;
    type: string;
    matchPrice: number;
    changeValue: number;
    changePercent: number;
    matchQtty: number;
    totalMatchQtty: number;
}
class OrderMatchingByPriceStore {
    chartHeight: number = 300
    @observable currentSymbol?: string = '';
    @observable stockSymbolInfo?: IStockSymbol
    @observable timeSymbol?: string = ''
    @observable keySearch: string = ""
    @observable showAutoCompleteForm: boolean = false
    @observable listShortCompany: IShortCompanyInfo[] = []
    @observable ViewType = OrderMatchingByPriceViewType.ByChart
    @observable areaLineChartData?: IAreaLineData
    @observable barChartData?: IBarData
    @observable pageIndex: number = 1
    @observable pageSize: number = 15
    @observable tableData: ITableData[] = []
    @observable loading:boolean=false
    listTime = listTime
    handleChageInputSearch(key: string) {
        orderMatchingByPriceStore.keySearch = key
        if (key) {
            orderMatchingByPriceStore.showAutoCompleteForm = true
            orderMatchingByPriceStore.listShortCompany.map((item) => {
                if (item.value.toUpperCase().indexOf(key.toUpperCase()) > -1) {
                    item.isHide = false
                }
                else item.isHide = true
            })
            let t = _.cloneDeep(orderMatchingByPriceStore.listShortCompany)
            t.sort((a, b) => {
                if (a.value.toLowerCase().indexOf(key.toLowerCase()) > b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return 1;
                } else if (a.value.toLowerCase().indexOf(key.toLowerCase()) < b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return -1;
                } else {
                    if (a.value > b.value)
                        return 1;
                    else
                        return -1;
                }
            });
            orderMatchingByPriceStore.listShortCompany = t
        }
        else {
            orderMatchingByPriceStore.showAutoCompleteForm = false
        }
    }
    getListShortCompany() {
        this.listShortCompany = _.cloneDeep(appStore.listShortCompany)
    }
    async handleSymbolSelect(symbol) {
        orderMatchingByPriceStore.showAutoCompleteForm = false
        orderMatchingByPriceStore.currentSymbol = symbol
        orderMatchingByPriceStore.keySearch = ""
        orderMatchingByPriceStore.initRequest(true)
        orderMatchingByPriceStore.regisListenStockSymbolUpdate()
    }
    async getAreaLineChartData(notDelay?: boolean) {
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'OrderMatchingByPriceAreaLine?code=' + this.currentSymbol, notDelay ? false : true)
        if (result.status < HttpStatusCode.CODE_300) {
            result.body.unknownData.map((item) => {
                // @ts-ignore
                item[0] = (new Date(new Date(item[0]).getTime()) - new Date(item[0]).getTimezoneOffset() * 60 * 1000);
            })
            result.body.priceData.map((item) => {
                // @ts-ignore
                item[0] = (new Date(new Date(item[0]).getTime()) - new Date(item[0]).getTimezoneOffset() * 60 * 1000);
            })
            this.areaLineChartData = result.body
        }
    }
    async getBarChartData(notDelay?: boolean) {
        let api = ""
        if (this.timeSymbol === "1") {
            api = "OrderMatchingByPriceBarStacks?code=" + this.currentSymbol
        }
        else api = "OrderMatchingByPriceBar?code=" + this.currentSymbol + "&day=" + this.timeSymbol
        this.barChartData=undefined
        this.loading=true
        const result = await getRequest(Constants.API_DASHBOARD_URL + api, notDelay||this.timeSymbol !== "1" ? false : true)
        this.loading=false
        if (result.status < HttpStatusCode.CODE_300) {
            this.barChartData = result.body
        }
    }
    async getTableData(notDelay?: boolean) {
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'OrderMatchingByPriceTable?code=' + this.currentSymbol + '&pageIndex=' + this.pageIndex + '&pageSize=' + this.pageSize)
        if (result.status < HttpStatusCode.CODE_300) {
            this.tableData = [...this.tableData, ...result.body]
        }
    }
    handleScrollTable = (e) => {
        const isBottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
        if (isBottom) {
            this.pageIndex += 1
            this.getTableData()
        }
    }
    initRequest(notDelay?: boolean) {
        if (this.ViewType === OrderMatchingByPriceViewType.ByChart) {
            this.getAreaLineChartData(notDelay);
            this.getBarChartData(notDelay)
        }
        else {
            this.pageIndex = 1
            this.tableData = []
            this.getTableData(notDelay)
            this.getBarChartData(notDelay)
        }
    }
    handleTimeSymbolChange(timeSymbol) {
        this.timeSymbol = timeSymbol
        this.barChartData = undefined
        this.getBarChartData(true)
    }
    handleViewTypeClick(viewType) {
        this.ViewType = viewType
        if (this.ViewType === OrderMatchingByPriceViewType.ByChart) {
            this.getAreaLineChartData(true);
        }
        else {
            this.pageIndex = 1
            this.getTableData(true)
        }
    }
    regisListenStockSymbolUpdate() {
        appStore.regisShortStockInfo()

        // setInterval(() => {
        //     const fake: any = {
        //         "floorCode": "10",
        //         "stockSymbol": "AAA",
        //         "time": "11:02:59",
        //         "basicPrice": 18.7,
        //         "ceilingPrice": 20,
        //         "floorPrice": 17.4,
        //         "matchPrice": Math.random()*100,
        //         "matchQtty": 100,
        //         "matchValue": 0.02,
        //         "totalTradingQtty": 3881700,
        //         "totalTradingValue": 73430,
        //         "highestPrice": 1920,
        //         "lowestPrice": 1865,
        //         "transId": null
        //     }
        //     this.updateMarketOverViewInfo([
        //         fake
        //     ])
        // },3000)
    }
    async updateMarketOverViewInfo(data: IMarketIndex[]) {
        let newStock = data.find((index) => (index.stockSymbol === this.currentSymbol))
        if (newStock) {
            let t: IStockSymbol = _.cloneDeep(newStock);
            if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice < t.matchPrice) {
                t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
            }
            if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice > t.matchPrice) {
                t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
            }
            if (this.stockSymbolInfo) {
                if (this.stockSymbolInfo.matchPrice !== t.matchPrice) {
                    this.stockSymbolInfo = t
                    setTimeout(() => {
                        if (this.stockSymbolInfo)
                            this.stockSymbolInfo.colorUpdate = ""
                    }, Constants.EFFECT_UPDATE_TIME)
                    this.stockSymbolInfo = t
                }
            }
            else {
                this.stockSymbolInfo = t
                setTimeout(() => {
                    if (this.stockSymbolInfo)
                        this.stockSymbolInfo.colorUpdate = ""
                }, Constants.EFFECT_UPDATE_TIME)
                this.stockSymbolInfo = t
            }

            // setTimeout(() => {
            //     if (this.topUpDownStockInfo) {
            //         this.topUpDownStockInfo[index].isUpdate = false
            //     }
            // }, 100)
        }

    }
}
export const orderMatchingByPriceStore = new OrderMatchingByPriceStore()